import React, { useEffect, useState } from "react";
import { Loader2, ArrowRight } from "lucide-react";
import { api } from "../../lib/api";

export default function StaffHome({ role, onGo }) {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/fx/my-stats").then((r) => setD(r.data)).catch(() => setD({ cards: [] })); }, []);
  if (!d) return <div className="flex justify-center py-16"><Loader2 className="animate-spin text-[#306D29]" /></div>;
  return (
    <div data-testid="fx-home">
      <p className="text-[#5C5C5C] mb-6">Welcome back{d.name ? `, ${d.name}` : ""}. Here's your work at a glance.</p>
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-4">
        {d.cards.map((c, i) => (
          <button key={i} onClick={() => onGo(c.tab)} data-testid={`fx-home-card-${i}`}
            className="bg-white border border-black/5 rounded-2xl p-6 text-left hover:border-[#306D29]/40 hover:shadow-[0_10px_28px_rgba(13,83,14,0.08)]"
            style={{ transition: "border-color 0.2s ease, box-shadow 0.2s ease" }}>
            <p className={`font-display text-5xl ${c.tone === "amber" ? "text-[#D9933B]" : "text-[#0D530E]"}`}>{c.value}</p>
            <p className="text-sm text-[#5C5C5C] mt-2 flex items-center gap-1">{c.label} <ArrowRight size={14} /></p>
          </button>
        ))}
        {d.cards.length === 0 && <p className="text-[#5C5C5C]">No metrics for your role yet.</p>}
      </div>
    </div>
  );
}
